import i18n from "../../i18n";

function bindEvents() {
    i18n.on("loaded", (test) => {
        i18n.loadNamespaces("attribute/attribute_type");
        updateTranslations();
    });

    i18n.on("languageChanged", (lang) => {
        i18n.loadNamespaces("attribute/attribute_type");
        updateTranslations();
    });
}

function updateTranslations() {
    Types.forEach(type => {
        const key = type.value.toLowerCase().split(" ").join("_");
        type.text = i18n.t("attribute_type_label." + key, { ns: "attribute/attribute_type" });
        type.description = i18n.t("attribute_type_description." + key, { ns: "attribute/attribute_type" });
    });
    Object.keys(TypeTextMap).forEach(key => {
        TypeTextMap[key] = i18n.t("attribute_type_label." + key.toLowerCase(), { ns: "attribute/attribute_type" });
    });
}

const Types = [
    {
        text: 'Text',
        icon: "far fa-text",
        value: 'String',
        description: "Input short information such as names, addresses, IDs, and others.",
        color: "#BCEBFF",
        imageName: "Text.png"
    },
    {
        text: 'Number',
        icon: "far fa-hashtag",
        value: 'Number',
        description: "Add numerical values, such as budget, discount rate, and any currencies.",
        color: "#BE8C648A",
        imageName: "Number.png"
    },
    {
        text: 'Dropdown',
        icon: "far fa-ballot-check",
        value: 'Picklist String',
        description: "Create a list of options where you can make single or multiple selections.",
        color: "#D8BAFF",
        imageName: "Dropdown.png"
    },
    {
        text: 'Date Time',
        icon: "far fa-calendar-alt",
        value: 'DateTime',
        description: "Add time specific values, such as deadline, birth date, and appointment time.",
        color: "#BCF986",
        imageName: "DateTime.png"
    },
    {
        text: 'User Identity',
        icon: "far fa-user",
        value: 'User Identity',
        description: "Show your added app users in a list, so you can do things such as assigning them tasks.",
        color: "#6CE2FCA8",
        imageName: "UserIdentity.png"
    },
    {
        text: 'Email',
        icon: "far fa-envelope",
        value: 'Email',
        description: "Trigger sending emails directly within the app in one click.",
        color: "#1E1AD95E",
        imageName: "Email.png"
    },
    {
        text: 'Link',
        icon: "far fa-link",
        value: 'URL',
        description: "Navigate to external websites or any URLs using a hyperlink.",
        color: "#F4BFBF",
        imageName: "URL.png"
    },
    {
        text: 'Rich Content',
        icon: "fa-solid fa-films",
        value: 'Html',
        description: "Add images, videos, and long paragraphs with rich formatting.",
        color: "#B1CFDB",
        imageName: "Rich Content.png"
    },
    {
        text: 'True/False',
        icon: "far fa-check-square",
        value: 'Boolean',
        description: "Add a checkbox to specify a true or false value. E.g., Is the client status active? It can be either a yes or a no.",
        color: "#FAF4B7",
        imageName: "Boolean.png"
    },
    {
        text: 'Long Text',
        icon: "far fa-align-left",
        value: 'Multiline Text',
        description: "Add more extended notes or comments without worrying about the text input limit.",
        color: "#F9E2BD",
        imageName: "Long Text.png"
    },
    {
        text: 'Tags',
        icon: "far fa-tags",
        value: 'Tags',
        description: "Any extra bits of information can be easily noted using tags.",
        color: "#AEE1B6",
        imageName: "Tags.png"
    },
    {
        text: 'State',
        icon: "far fa-arrow-progress",
        value: 'State Field',
        description: "Add a state to track the progress of a task or project etc.",
        color: "#AEE1B6",
        imageName: "State Field.png"
    },
    {
        text: 'Tree Dropdown',
        icon: "far fa-list-tree",
        value: 'Tree Dropdown',
        description: "Create a list of options where you can make single or multiple selections.",
        color: "#D8BAFF",
        imageName: "Tree Dropdown.png"
    },
    {
        text: "Image",
        icon: "far fa-image",
        value: "Image",
        description: "Add images to your app.",
        color: "#BE8C648A",
        imageName: "Image.png"
    },
    {
        text: "Mirror",
        icon: "far fa-clone",
        value: "Mirror",
        description: "Mirror the value of another property.",
        color: "#D8BAFF",
        imageName: "Mirror.png"
    },
    {
        text: 'Shared Property',
        icon: "far fa-list-tree",
        value: 'Shared Lookup',
        description: "create a shared property",
        color: "#D8BAFF",
        imageName: "Tree Dropdown.png"
    },
    {
        text: "Custom Id",
        icon: "fa-thin fa-arrow-up-1-9",
        value: "Custom Id",
        description: "Human-readable, unique identifier for easy reference and search.",
        color: "#D8BAFF",
        imageName: "Custom Id.png"
    },
    {
        text: "Attachment",
        icon: "fa-solid fa-paperclip",
        value: "Attachment",
        description: "Upload and manage different types of attachment files directly.",
        color: "#D8BAFF",
        imageName: "Attachment.png"
    }
];

export const Icons = {
    String: "far fa-text",
    Number: "far fa-hashtag",
    "Picklist String": "far fa-ballot-check",
    DateTime: "far fa-calendar-alt",
    "User Identity": "far fa-user",
    Email: "far fa-envelope",
    URL: "far fa-link",
    Html: "fa-solid fa-films",
    Boolean: "far fa-check-square",
    "Multiline Text": "far fa-align-left",
    Tags: "far fa-tags",
    "Tree Dropdown": "far fa-list-tree",
    "Shared Lookup": "far fa-list-tree",
    "State Field": "far fa-arrow-progress",
    "Entity Lookup": "far fa-brackets",
    Image: "far fa-image",
    Mirror: "far fa-clone",
    "Custom Id": "fa-thin fa-arrow-up-1-9",
    "Attachment": "fa-solid fa-paperclip"
};

const BaseFields = [
    {
        field: "attributeName",
        state: "attributeName",
        defaultValue: "",
        allowEmpty: false,
        type: "string"
    },
    {
        field: "attributeLabel",
        fieldLabel: "Label",
        state: "attributeLabel",
        defaultValue: "",
        allowEmpty: true,
        type: "string"
    },
    {
        field: "languages",
        fieldLabel: "Label Translation",
        state: "languages",
        defaultValue: {},
        allowEmpty: true,
        type: "object"
    },
    {
        field: "attributeType",
        state: "attributeType",
        defaultValue: "String",
        allowEmpty: false,
        type: "string",
    },
    {
        field: "group",
        fieldLabel: "Group",
        state: "group",
        defaultValue: "",
        allowEmpty: true,
        type: "string"
    },
    {
        field: "required",
        fieldLabel: "Required",
        state: "required",
        defaultValue: true,
        allowEmpty: true,
        type: "boolean"
    },
    {
        field: "defaultValue",
        fieldLabel: "Default Value",
        state: "defaultValue",
        defaultValue: "",
        allowEmpty: true,
        type: "string"
    },
    {
        field: "description",
        fieldLabel: "Description",
        state: "description",
        defaultValue: "",
        allowEmpty: true,
        type: "string"
    },
    {
        field: "tooltip",
        fieldLabel: "tooltip",
        state: "tooltip",
        defaultValue: "",
        allowEmpty: true,
        type: "string"
    },
    {
        field: "readOnly",
        fieldLabel: "Read-Only",
        state: "readOnly",
        defaultValue: false,
        allowEmpty: true,
        type: "boolean"
    },
    {
        field: "formula",
        fieldLabel: "",
        state: "formula",
        allowEmpty: true,
        type: "string"
    },
    {
        field: "formulaJson",
        fieldLabel: "",
        state: "formulaJson",
        allowEmpty: true,
        type: "string"
    },
    {
        field: "triggerSetting",
        fieldLabel: "",
        state: "triggerSetting",
        allowEmpty: true,
        type: "string"
    }
]

export const Fields = {
    "Base": BaseFields,
    "String": [
        ...BaseFields,
        {
            field: "min",
            state: "min",
            defaultValue: "",
            allowEmpty: true,
            type: "string"
        },
        {
            field: "max",
            state: "max",
            defaultValue: "",
            allowEmpty: true,
            type: "string"
        },
        {
            field: "pattern",
            state: "pattern",
            defaultValue: "",
            allowEmpty: true,
            type: "string"
        },
        {
            field: "unique",
            fieldLabel: "Unique",
            state: "unique",
            defaultValue: false,
            allowEmpty: true,
            type: "boolean"
        },
        {
            field: "dummyLabel",
            state: "dummyLabel",
            defaultValue: "",
            allowEmpty: false,
            type: "string"
        },
    ],
    "Number": [
        ...BaseFields,
        {
            field: "decimalPlace",
            state: "decimalPlace",
            defaultValue: "2",
            allowEmpty: false,
            type: "string"
        },
        {
            field: "unit",
            state: "unit",
            defaultValue: "none",
            allowEmpty: false,
            type: "string"
        },
        {
            field: "unitSide",
            state: "unitSide",
            defaultValue: "Right",
            allowEmpty: false,
            type: "string"
        },
        {
            field: "useThousandSeparator",
            state: "useThousandSeparator",
            defaultValue: false,
            allowEmpty: false,
            type: "boolean"
        },
        {
            field: "numberType",
            state: "numberType",
            defaultValue: "integer",
            allowEmpty: true,
            type: "string"
        },
        {
            field: "min",
            state: "min",
            defaultValue: "",
            allowEmpty: true,
            type: "string"
        },
        {
            field: "max",
            state: "max",
            defaultValue: "",
            allowEmpty: true,
            type: "string"
        },
        {
            field: "cellFormatting",
            state: "cellFormatting",
            defaultValue: {},
            allowEmpty: false,
            type: "object"
        }
    ],
    "Picklist String": [
        ...BaseFields,
        {
            field: "picklist",
            state: "picklist",
            defaultValue: "",
            allowEmpty: true,
            type: "string"
        },
        {
            field: "multiSelect",
            state: "multiSelect",
            defaultValue: false,
            allowEmpty: true,
            type: "boolean"
        },
        {
            field: "cellFormatting",
            state: "cellFormatting",
            defaultValue: {},
            allowEmpty: false,
            type: "object"
        }
    ],
    "State Field": [
        ...BaseFields,
        {
            field: "statefield",
            state: "statefield",
            defaultValue: [],
            allowEmpty: true,
            type: "array"
        },
        {
            field: "rules",
            state: "rules",
            defaultValue: [],
            allowEmpty: true,
            type: "array"
        },
        {
            field: "setStatesRules",
            state: "setStatesRules",
            defaultValue: false,
            allowEmpty: true,
            type: "boolean"
        },
        {
            field: "allowOnlyTransitionConfigurations",
            state: "allowOnlyTransitionConfigurations",
            defaultValue: true,
            allowEmpty: true,
            type: "boolean"
        },
        {
            field: "cellFormatting",
            state: "cellFormatting",
            defaultValue: {},
            allowEmpty: false,
            type: "object"
        }
    ],
    "Tree Dropdown": [
        ...BaseFields,
        {
            field: "treeDropdown",
            state: "treeDropdown",
            defaultValue: [],
            allowEmpty: true,
            type: "array"
        }
    ],
    "DateTime": [
        ...BaseFields,
        {
            field: "dateTimeType",
            state: "dateTimeType",
            defaultValue: "date",
            allowEmpty: false,
            type: "string"
        },
        {
            field: "minTime",
            state: "minTime",
            defaultValue: "",
            allowEmpty: false,
            type: "string"
        },
        {
            field: "interval",
            state: "interval",
            defaultValue: "30",
            allowEmpty: false,
            type: "string"
        },
        {
            field: "maxTime",
            state: "maxTime",
            defaultValue: "",
            allowEmpty: false,
            type: "string"
        },
        {
            field: "defaultTime",
            state: "defaultTime",
            defaultValue: "10:00 AM",
            allowEmpty: false,
            type: "string"
        },
        {
            field: "setDefaultDate",
            state: "setDefaultDate",
            defaultValue: false,
            allowEmpty: false,
            type: "boolean"
        },
        {
            field: "defaultDate",
            state: "defaultDate",
            defaultValue: "Today_+_0_Days",
            allowEmpty: false,
            type: "string"
        },
        {
            field: "cellFormatting",
            state: "cellFormatting",
            defaultValue: {},
            allowEmpty: false,
            type: "object"
        }
    ],
    "User Identity": [
        ...BaseFields,
        {
            field: "showProfilePicture",
            state: "showProfilePicture",
            defaultValue: true,
            allowEmpty: false,
            type: "boolean"
        },
        {
            field: "useDisplayName",
            state: "useDisplayName",
            defaultValue: true,
            allowEmpty: false,
            type: "boolean"
        },
        {
            field: "multiSelect",
            state: "multiSelect",
            defaultValue: false,
            allowEmpty: false,
            type: "boolean"
        }
    ],
    "Email": [
        ...BaseFields,
        {
            field: "dummyLabel",
            state: "dummyLabel",
            defaultValue: "Email",
            allowEmpty: false,
            type: "string"
        }
    ],
    "URL": [
        ...BaseFields,
        {
            field: "dummyLabel",
            state: "dummyLabel",
            defaultValue: "Url",
            allowEmpty: false,
            type: "string"
        }
    ],
    "Html": [
        ...BaseFields,
        {
            field: "dummyLabel",
            state: "dummyLabel",
            defaultValue: "Nature",
            allowEmpty: false,
            type: "string"
        }
    ],
    "Boolean": [
        ...BaseFields,
        {
            field: "defaultValue",
            fieldLabel: "Default Value",
            state: "defaultValue",
            defaultValue: false,
            allowEmpty: true,
            type: "boolean"
        }
    ],
    "Multiline Text": [
        ...BaseFields,
        {
            field: "dummyLabel",
            state: "dummyLabel",
            defaultValue: "Sentence",
            allowEmpty: false,
            type: "string"
        }
    ],
    "Tags": [
        ...BaseFields,
        {
            field: "cellFormatting",
            state: "cellFormatting",
            defaultValue: {},
            allowEmpty: false,
            type: "object"
        }
    ],
    "Entity Lookup": [
        ...BaseFields
    ],
    "Image": [
        ...BaseFields,
        {
            field: "allowedFileTypes",
            state: "allowedFileTypes",
            defaultValue: [],
            allowEmpty: true,
            type: "array"
        },
        {
            field: "maxNumberOfImages",
            state: "maxNumberOfImages",
            defaultValue: 1,
            allowEmpty: false,
            type: "number"
        },
        {
            field: "maxFileSize",
            state: "maxFileSize",
            defaultValue: 5,
            allowEmpty: false,
            type: "number"
        },
    ],
    "Shared Lookup": [
        ...BaseFields,
    ],
    "Mirror": [
        ...BaseFields,
        {
            field: "attribute",
            state: "attribute",
            defaultValue: "",
            allowEmpty: false,
            type: "object"
        },
        {
            field: "entity",
            state: "entity",
            defaultValue: "",
            allowEmpty: false,
            type: "object"
        },
        {
            field: "relation",
            state: "relation",
            defaultValue: "",
            allowEmpty: false,
            type: "object"
        },
        {
            field: "relationId",
            state: "relationId",
            defaultValue: "",
            allowEmpty: false,
            type: "object"
        },
        {
            field: "cellFormatting",
            state: "cellFormatting",
            defaultValue: {},
            allowEmpty: false,
            type: "object"
        }
    ],
    "Custom Id": [
        ...BaseFields,
        {
            field: "unique",
            fieldLabel: "Unique",
            state: "unique",
            defaultValue: false,
            allowEmpty: true,
            type: "boolean"
        },
        {
            field: "prefix",
            fieldLabel: "Prefix",
            state: "prefix",
            defaultValue: "",
            allowEmpty: true,
            type: "string"
        },
    ],
    "Attachment": [
        ...BaseFields,
        {
            field: "attachmentTypes",
            state: "attachmentTypes",
            defaultValue: ["PDF"],
            allowEmpty: false,
            type: "array"
        },
        {
            field: "maxNumberOfAttachments",
            state: "maxNumberOfAttachments",
            defaultValue: 1,
            allowEmpty: false,
            type: "number"
        },
        {
            field: "maxAttachmentSize",
            state: "maxAttachmentSize",
            defaultValue: 30,
            allowEmpty: false,
            type: "number"
        },
    ]
}

const Operations = [
    {
        type: "Number",
        operators: ['exponent', 'absolute', "round", "ceil", "floor"],
        linkedOperators: ['count', 'min', 'max', 'avg', 'sum'],
        multiOperators: ['divide', 'multiply', 'subtract', 'add', 'modular'],
        multiDateOperators: ['days between', 'weeks between', 'months between', 'years between'],
        multiTimeOperators: ['minutes between', 'hours between'],
        connectors: ['add', 'divide', 'subtract', 'multiply']
    },
    {
        type: "String",
        operators: ['capitalize', 'lower case', 'first letter'],
        connectors: ['concatenate']
    },
    {
        type: "DateTime",
        operators: ['plus', 'minus'],
        connectors: []
    }
];

// A static object of value to text of Types
// TODO: Add image type
const TypeTextMap = {
    "String": "Text",
    "Number": "Number",
    "Picklist String": "Dropdown",
    "DateTime": "Date Time",
    "User Identity": "User Identity",
    "Email": "Email",
    "URL": "Link",
    "Html": "Rich Content",
    "Boolean": "True/False",
    "Multiline Text": "Long Text",
    "Tags": "Tags",
    "Tree Dropdown": "Tree Dropdown",
    "Shared Lookup": "Shared Property",
    "State Field": "State",
    "Entity Lookup": "Reference Property",
    "Image": "Image",
    "Mirror": "Mirror",
    "Custom Id": "Custom Id",
    "Attachment": "Attachment"
};

function getTranslatedTypes(t) {
    return Types.map(type => {
        const key = type.value.toLowerCase().split(" ").join("_");
        return {
            ...type,
            text: t("attribute_type_label." + key, { ns: "attribute/attribute_type" })
        }
    })
}

export default {
    bindEvents,
    Types,
    TypeTextMap,
    Icons,
    Fields,
    Operations,
    getTranslatedTypes
}